/** Whether text on this hex color should be dark, so it stays readable
 * whatever color the user picked. Alpha is ignored. */
export const isLightColor = (hex: string) => {
  const value = hex.replace("#", "");
  const [r, g, b] = [0, 2, 4].map(
    (i) => parseInt(value.slice(i, i + 2), 16) / 255,
  );

  if ([r, g, b].some(Number.isNaN)) {
    return true;
  }

  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.6;
};

export const randomHexColor = () =>
  "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0");
